import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import ImageUpload from "components/shared/ImageUpload";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";
import { handleImage } from "helpers/functions";
import { toast } from "react-toastify";

const Services = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);

  const [selectedBackgroundImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const [sliders, setSliders] = useState([]);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "customerReviews",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset({
      heading: {
        ar: section?.heading?.ar,
        en: section?.heading?.en
      },
      subHeading: {
        ar: section?.subHeading?.ar,
        en: section?.subHeading?.en
      },
    });


    setSelectedImage({
      preview: null,
      path: section?.backgroundImage,
    });
    setSliders(section?.sliders);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
 
    data.sliders = sliders?.map((item) => ({
      ...item,
      image: `/uploads/${item?.image?.split("/").pop()}`,
    }));
    dispatch(
      editSection({ slug: "customerReviews", page: "home", data: { section: data } , toast })
    );
  };

  if (loading) return <Loader />;
  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"customerReviews"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col md={12}>

                {/* heading  */}
                <Row>
                <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            {" "}
                            <FormattedMessage id={"heading"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <input
                            type="text"
                            {...register("heading.ar", { required: true })}
                            className="form-control form-outline"
                            defaultValue={section?.heading?.ar}
                           
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            {" "}
                            <FormattedMessage id={"heading"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <input
                            type="text"
                            {...register("heading.en", { required: true })}
                            className="form-control form-outline"
                            defaultValue={section?.heading?.en}
                          />
                        </div>
                      </Col>


                </Row>

                {/* subHeading  */}
                <Row>
                <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            {" "}
                            <FormattedMessage id={"subHeading"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <input
                            type="text"
                            {...register("subHeading.ar", { required: true })}
                            className="form-control form-outline"
                            defaultValue={section?.subHeading?.ar}
                           
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            {" "}
                            <FormattedMessage id={"subHeading"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <input
                            type="text"
                            {...register("subHeading.en", { required: true })}
                            className="form-control form-outline"
                            defaultValue={section?.subHeading?.en}
                          />
                        </div>
                      </Col>


                </Row>
                <Row>
                  <Col lg={12}>
                    <SlidersArray sliders={sliders} setSliders={setSliders}  register={register}/>
                  </Col>
                </Row>

                {/* backgroundImage  */}
                {/* <Col lg={12} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"backgroundImage"} />
                    </h5>
                    <ImageUpload
                      selectedImage={selectedBackgroundImage}
                      setSelectedImage={setSelectedImage}
                    />
                  </div>
                </Col> */}

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
